<template>
  <div>
    <el-dialog class="dialog"  :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="visible">
      <div class="mt5-content">
        <div class="mt5-title">{{$t('setting.changeMt5Pwd')}}</div>
        <div class="mt5-tip">{{$t('setting.pwdTip')}}</div>
        <el-form ref="newPasswordForm" :rules="rules" :model="form" label-width="0">
          <el-form-item prop="oldPassword" label="">
            <el-input type="password" autocomplete="off" :placeholder="$t('setting.pleaseEnterMaterPwd')"
              v-model="form.oldPassword">
            </el-input>
            <div class="forget-pwd" @click="forgetPwd">{{$t('setting.forgetPwd')}}?</div>
          </el-form-item>

          <el-form-item prop="type" label="">
            <el-radio-group v-model="form.type" @change="changeType">
              <el-radio label="USER_PASS_MAIN">{{$t('setting.masterPwd')}}</el-radio>
              <el-radio style="margin-left:0;" label="USER_PASS_INVESTOR">{{$t('setting.readOnlyPwd')}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="newPassword" label="">
            <el-input type="password" autocomplete="off" :placeholder="$t('setting.changePasswordMt5.inputNewPassword')"
              v-model="form.newPassword">
            </el-input>
          </el-form-item>
          <el-form-item prop="confirmPassword" label="">
            <el-input type="password" autocomplete="off"
              :placeholder="$t('setting.changePasswordMt5.inputNewPasswordAgain')" v-model="form.confirmPassword">
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="el-button--sub">
              <el-button :loading="loading" @click="changePwd('newPasswordForm')" type="primary">{{$t('common.ok')}}</el-button>
            </div>
            <div class="el-button--cencel">
              <el-button :disabled="cancel" @click="resetForm('newPasswordForm')" type="primary">{{$t('common.cancel')}}</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <success id="mt5Success" :visible.sync="successVisible" page_id="page_setting_success_confirm"></success>
    <resetPwd :mt5Info="params" :visible.sync="resetMt5Visible" ></resetPwd>
  </div>
</template>
<script>
import tradeApi from '@/api/v2/trade.js'
import success from './success'
import resetPwd from './resetPwd.vue'
export default {
  data () {
    const checkNewPassword = (rule, value, callback) => {
      // 6-16位数字字母组合
      let patrn = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,15}$/
      if (!value) {
        return callback(new Error(this.$t('common.inputNewPassword')))
      } else if (!patrn.exec(value)) {
        return callback(new Error(this.$t('setting.changePasswordMt5.checkPassword')))
      } else if (checkPass(value) < 3) {
        return callback(new Error(this.$t('setting.changePasswordMt5.30001')))
      } else {
        callback()
      }
    }
    /**
     * 校验密码规则是否跟mt5的规则一致 大小写加字母最少六位数
     * @param {密码} pass
     */
    const checkPass = (pass) => {
      let ls = 0
      if (pass.length < 6) return ls
      if (pass.length > 15) return ls
      pass.match(/([a-z])+/) && ls++
      pass.match(/([0-9])+/) && ls++
      pass.match(/([A-Z])+/) && ls++
      pass.match(/[^a-zA-Z0-9]+/) && ls++
      return ls
    }
    const checkConfirmPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('common.inputNewPasswordAgain')))
      } else if (value !== this.form.newPassword) {
        return callback(new Error(this.$t('common.notIdentical')))
      } else {
        callback()
      }
    }
    return {
      form: {
        type: 'USER_PASS_MAIN'
      },
      rules: {
        oldPassword: [{ required: true, message: this.$t('setting.pleaseEnterMaterPwd') }],
        newPassword: [{ validator: checkNewPassword, trigger: 'change' }],
        confirmPassword: [{ validator: checkConfirmPassword, trigger: 'change' }]
      },
      loading: false,
      cancel: false,
      successVisible: false,
      resetMt5Visible: false
    }
  },
  props: ['params', 'visible'],
  components: { success, resetPwd },
  methods: {
    changeType () {
      this.form.newPassword = ''
      this.form.confirmPassword = ''
      this.$nextTick(() => {
        this.$refs['newPasswordForm'].clearValidate()
      })
    },
    changePwd () {
      this.$refs['newPasswordForm'].validate(valid => {
        if (!valid) {
          return
        }
        let params = {
          'confirmPassword': this.form.confirmPassword,
          'newPassword': this.form.newPassword,
          'oldPassword': this.form.oldPassword,
          'tradeAccountNumber': this.params.tradeAccountNumber,
          'type': this.form.type
        }
        console.log(params, 232232)
        tradeApi.changeMt5Password(params).then(res => {
          if (res.code === 200) {
            this.$message.success('修改成功')
            this.resetForm()
            this.resetForm()
            this.successConfirm()
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    resetForm () {
      this.$refs['newPasswordForm'].resetFields()
      this.$emit('update:visible', false)
    },
    successConfirm () {
      // this.$refs.successConfirm.dialogFormVisible = true
      this.successVisible = true
    },
    forgetPwd () {
      this.$emit('update:visible', false)
      this.resetMt5Visible = true
      // this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.$message({
      //     type: 'success',
      //     message: '删除成功!'
      //   })
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消删除'
      //   })
      // })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog {
  .el-dialog {
    max-width: 500px;
    max-height: 560px;
  }

  .el-dialog__body {
    padding: 20px 70px 56px;
  }
  @media (max-width: 768px) {
    .el-dialog__body {
      padding: 30px 20px;
    }
  }
}
.mt5-title {
  font-size: 22px;
  text-align: center;
  margin-bottom: 15px;
  font-weight: 600;
  margin-top: -10px;
}
.mt5-tip {
  margin-bottom: 20px;
  font-size: 14px;
  color: #24282d;
  text-align: center;
}
.el-button--sub {
  width: 100%;
  .el-button {
    width: 100%;
    color: #192b57;
    font-weight: bold;
    height: 56px;
    border-color: #ffe080;
    background-color: #fecd33;
  }
}

.el-button--cencel {
  width: 100%;

  .el-button {
    margin-top: 20px;
    width: 100%;
    color: #192b57;
    font-weight: bold;
    height: 56px;
    border-color: #192b57;
    background-color: #fff;
  }
}
.forget-pwd {
  position: absolute;
  right: 0;
  line-height: 30px;
  color: #3773e1;
  font-size: 13px;
  cursor: pointer;
}
/deep/.el-radio{
  padding-left: 0;
}
</style>
